import {LIMPAR_ULTIMOS_HISTORICOS_USUARIO} from '../types';

export default function limparUltimosHIstoricosUsuario () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_USUARIO
    }
}
